export default __webpack_public_path__ + "static/media/Ancient Blade.3fccb2ee.jpg";